.edit-cover {
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  font-size: 1.4rem;
  border-radius: var(--border-radius-small);
  padding: 0.2rem 0.8rem;
  color: white;
  background: black;
  opacity: 0;
  transform: translateX(1rem) scale(0.95);
  transition: all 0.1s ease-in;
  user-select: none;

  &:hover {
    cursor: pointer;
  }
}
